import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { ArrowRight, Gift, CheckCircle2, Clock, Info } from "lucide-react";
import NumberFormat from "react-number-format";
import DiscountComparisonContent from "./DiscountComparisonContent";
import GroupAccountBanner from "./GroupAccountBanner";

const PromoBanner = ({
  orderCount = 0,
  threshold = 3,
  promoCap = 2000,
  rateConfig,
  businessType,
}) => {
  const location = useLocation();
  const pathname = location?.pathname || "";
  const [showDiscountModal, setShowDiscountModal] = useState(false);

  const isWholesaleOrRetail =
    businessType === "raw_food" ||
    businessType === "store" ||
    businessType === "wholesale" ||
    businessType === "retail" ||
    pathname.includes("/raw_food") ||
    pathname.includes("/store");

  if (isWholesaleOrRetail) {
    return null;
  }
  const isQualified = orderCount >= threshold - 1 && orderCount < threshold;
  const isPostQualified = orderCount >= threshold;
  const remaining = Math.max(0, threshold - orderCount);
  const displayCap =
    rateConfig?.weekStartBonusCapped ||
    rateConfig?.promoCap ||
    promoCap ||
    2000;
  const discountPercent = rateConfig?.weekStartDiscountPercentageSlot || 70;
  const baseDiscount =
    rateConfig?.bonusDiscountWithoutBalanceSD ??
    rateConfig?.weekStartDiscountPercentageWithoutSlot ??
    12;
  const wkOrder3rdDiscountPercent =
    rateConfig?.wkOrder3rdDiscountPercentage || 60;

  const renderProgressDots = () => {
    return (
      <div className="flex gap-2 mt-2 mb-2">
        {Array.from({ length: threshold }).map((_, index) => (
          <div
            key={index}
            className={`h-2 w-10 btn-rounded-sm transition-all duration-500 ${index < orderCount
                ? "bg-white shadow-[0_0_8px_rgba(255,255,255,0.8)]"
                : "bg-white/30"
              }`}
          />
        ))}
      </div>
    );
  };

  if (isPostQualified) {
    return (
      <div className="px-4 py-2 w-full animate-in fade-in slide-in-from-bottom-4 duration-700">
        <div className="relative overflow-hidden rounded-2xl p-5 shadow-sm border border-emerald-100 bg-white">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-emerald-100 rounded-lg">
              <CheckCircle2 className="w-5 h-5 text-emerald-600" />
            </div>
            <div>
              <p className="text-gray-500">
                You've successfully used your {wkOrder3rdDiscountPercent}%
                automatic discount for this week. Thank you
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="px-4 py-2 w-full animate-in fade-in slide-in-from-bottom-4 duration-700">
      <GroupAccountBanner />
    </div>
  );

  // if (isQualified) {
  //   return (
  //     <div className="px-4 py-2 w-full animate-in fade-in slide-in-from-bottom-4 duration-700">
  //       <GroupAccountBanner />
  //     </div>
  //   );
  // }

  // return (
  //   <div className="px-4 py-2 w-full animate-in fade-in slide-in-from-bottom-4 duration-700">
  //     <div
  //       onClick={() => setShowDiscountModal(true)}
  //       className="relative overflow-hidden rounded-2xl shadow-xl flex cursor-pointer"
  //       style={{
  //         background:
  //           "linear-gradient(135deg, #4338ca 0%, #4f46e5 50%, #6366f1 100%)",
  //       }}
  //     >
  //       <div className="relative flex-1 p-5 flex flex-col items-start gap-1">
  //         <div className="flex items-center gap-2 mb-1">
  //           <div className="p-1.5 bg-white/20 rounded-lg backdrop-blur-md">
  //             <Gift className="w-4 h-4 text-white" />
  //           </div>
  //           <span className="text-white/80 text-xs font-gilroyBold tracking-wider uppercase">
  //             Special Offer
  //           </span>
  //         </div>

  //         <h2 className="text-white text-xl font-gilroyBold leading-tight">
  //           {remaining} order{remaining > 1 ? "s" : ""} to get{" "}
  //           <span className="text-yellow-300 font-gilroyBold uppercase">
  //             AUTOMATIC {wkOrder3rdDiscountPercent}% DISCOUNT
  //           </span>{" "}
  //           (Weekly)
  //         </h2>

  //         {renderProgressDots()}

  //         <div className="flex flex-col gap-1 mt-1">
  //           <div className="flex items-center gap-2 text-white/90 text-[12px]">
  //             <Clock className="w-3.5 h-3.5" />
  //             <span>Valid till Saturday 11pm</span>
  //           </div>
  //           <div className="flex items-center gap-2 text-white/90 text-[12px]">
  //             <Info className="w-3.5 h-3.5" />
  //             <span>Discount is capped accordingly</span>
  //           </div>
  //         </div>
  //       </div>

  //       <div
  //         className="flex flex-col items-center justify-center px-2"
  //         style={{
  //           background: "#f5b731",
  //           writingMode: "vertical-rl",
  //           minWidth: "48px",
  //         }}
  //       >
  //         <span className="text-black font-gilroyBold text-xl">
  //           {wkOrder3rdDiscountPercent}% DISCOUNT
  //         </span>
  //         <span
  //           className="text-black/80 text-lg font-gilroyBold"
  //           style={{ writingMode: "vertical-rl" }}
  //         >
  //           (read more)
  //         </span>
  //       </div>
  //     </div>

  //     <DiscountComparisonContent
  //       open={showDiscountModal}
  //       onClose={() => setShowDiscountModal(false)}
  //       promoCap={promoCap}
  //       rateConfig={rateConfig}
  //     />
  //   </div>
  // );
};

export default PromoBanner;
